import { render, staticRenderFns } from "./ThePageIntro.vue?vue&type=template&id=898885cc&scoped=true&"
import script from "./ThePageIntro.vue?vue&type=script&lang=js&"
export * from "./ThePageIntro.vue?vue&type=script&lang=js&"
import style0 from "./ThePageIntro.vue?vue&type=style&index=0&id=898885cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898885cc",
  null
  
)

export default component.exports